import { gql } from '@apollo/client';

export const CRM_EMAIL_TEMPLATE_FIELDS = `
    _id
    name
    subject
    templateType
    body
    design
    bodyHtml
    createdAt
    updatedAt
`;

export const LIST_CRM_EMAIL_TEMPLATES = gql`
    query ListCrmEmailTemplates {
        listCrmEmailTemplates {
            ${CRM_EMAIL_TEMPLATE_FIELDS}
        }
    }
`;

export const GET_CRM_EMAIL_TEMPLATE = gql`
    query GetCrmEmailTemplate($id: String!) {
        getCrmEmailTemplate(id: $id) {
            ${CRM_EMAIL_TEMPLATE_FIELDS}
        }
    }
`;

/**
 * The canonical merge-tag catalog (POGO-12603 Phase 6) — one source of truth
 * with the backend renderer, shared by every CRM email surface.
 */
export const CRM_MERGE_TAGS = gql`
    query CrmMergeTags {
        crmMergeTags {
            token
            label
            category
        }
    }
`;
